import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chatStatus:{
     color:"#fff",
     padding:"10px 36px",
     position:"relative",
     fontStyle:"italic"
    },
    chatStatusIcon:{
        position:"absolute",
        left:"5px"
    },
    iconCircle:{
        width:"100px",
        height:"100px",
        borderRadius:"50%",
        color:"#fff",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        margin:"0 auto"
    },
    iconText:{
        fontSize:"36px",
        fontWeight:"bold"
    }
  }),
);

export default useStyles;
